import { Reducer } from 'redux'
import {
  ActionTypes,
  LANDING_PAGE_ACTIONS,
  PersonalAccount,
  TemporaryHoldingBalance,
  Transaction,
  DepositRequest,
  PersonalVerificationStatus,
  DashboardBanner,
} from './types'
import { Moment } from '~/types'

const initialState = {
  // user related fields, currently getting from API_V3_USER
  name: '',
  verificationStatus: null,

  // personal account related fields
  personalAccount: null,
  temporaryHoldingBalance: null,
  latestPersonalTransactions: null,
  latestPersonalDepositRequests: null,
  limitationIncreaseAmount: null,
  limitationIncreaseDate: null,

  // misc
  gauthEnabled: true,
  personalVerificationStatus: null,

  isErc20Enabled: true,
  isZrc2Enabled: true,
  isZrc2NoticeBannerVisible: false,
  isLongerProcessingNoticeBannerVisible: false,

  kycVerified: false,
  kycVerifiedDate: null,

  isDashboardBannerManagementEnabled: false,
  dashboardBanners: [],
}

type State = {
  name: string
  verificationStatus: 'initial' | 'verified' | 'pending' | 'rejected' | null

  personalAccount: PersonalAccount | null
  temporaryHoldingBalance: TemporaryHoldingBalance | null
  latestPersonalTransactions: Transaction[] | null
  latestPersonalDepositRequests: DepositRequest[] | null
  limitationIncreaseAmount: number | null
  limitationIncreaseDate: Moment | null

  gauthEnabled: boolean
  personalVerificationStatus: PersonalVerificationStatus | null

  isErc20Enabled: boolean
  isZrc2Enabled: boolean
  isZrc2NoticeBannerVisible: boolean
  isLongerProcessingNoticeBannerVisible: boolean

  kycVerified: boolean
  kycVerifiedDate: Moment | null
  isDashboardBannerManagementEnabled: boolean
  dashboardBanners: DashboardBanner[]
}

export const landingPage: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case LANDING_PAGE_ACTIONS.SET_USER_INFO: {
      return {
        ...state,
        name: action.name,
        verificationStatus: action.verificationStatus,
        kycVerified: action.kycVerified,
        kycVerifiedDate: action.kycVerifiedDate,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_PERSONAL_ACCOUNT: {
      return {
        ...state,
        personalAccount: action.personalAccount,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_TEMP_HOLDING_BALANCE: {
      return {
        ...state,
        temporaryHoldingBalance: action.temporaryHoldingBalance,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_LATEST_PERSONAL_TRANSACTIONS: {
      return {
        ...state,
        latestPersonalTransactions: action.latestPersonalTransactions,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_LATEST_PERSONAL_DEPOSIT_REQUESTS: {
      return {
        ...state,
        latestPersonalDepositRequests: action.latestPersonalDepositRequests,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_PERSONAL_VERIFICATION_STATUS: {
      return {
        ...state,
        personalVerificationStatus: action.personalVerificationStatus,
        gauthEnabled: action.gauthEnabled,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_ERC20_ENABLED: {
      return {
        ...state,
        isErc20Enabled: action.isErc20Enabled,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_ZRC2_ENABLED: {
      return {
        ...state,
        isZrc2Enabled: action.isZrc2Enabled,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_ZRC2_NOTICE_BANNER_VISIBLE: {
      return {
        ...state,
        isZrc2NoticeBannerVisible: action.isZrc2NoticeBannerVisible,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_LONGER_PROCESSING_NOTICE_BANNER_VISIBLE: {
      return {
        ...state,
        isLongerProcessingNoticeBannerVisible: action.isLongerProcessingNoticeBannerVisible,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_DASHBOARD_BANNER_MANAGEMENT_ENABLED: {
      return {
        ...state,
        isDashboardBannerManagementEnabled: action.isDashboardBannerManagementEnabled,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_DASHBOARD_BANNERS: {
      return {
        ...state,
        dashboardBanners: action.dashboardBanners,
      }
    }

    default:
      return state
  }
}
